import { Stack, useMediaQuery } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { colors, theme } from "src/utils/theme";
import BuySellComponents from "./components/BuySellComponents";
import { renderChart } from "./helpers/RenderChartHelper";
import { IPosition } from "./types";

const Chart: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const parentRef = useRef<HTMLDivElement>(null);
  const markerRef = useRef<{ position: IPosition }>();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const bgcolor =
    theme.palette.mode === "dark" ? "transparent" : colors.gray[12];
  // theme.palette.mode === "dark" ? colors.gray[2] : colors.gray[12];

  useEffect(() => {
    renderChart({ parentRef, canvasRef, markerRef, isMobile });
    return () => {
      // canvasRef?.current?.remove();
    };
    // eslint-disable-next-line
  }, []);

  return (
    <Stack
      sx={{
        height: ["60vh", "340px", "100%"],
        bgcolor,
      }}
      ref={parentRef}
    >
      <BuySellComponents markerRef={markerRef} />
      <canvas id={"gamePlay"} ref={canvasRef} style={{ borderRadius: "8px" }} />
    </Stack>
  );
};

// export default React.memo(Chart);
export default Chart;
